/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_Email_PhInputs */

const vi_order_form_invoice_buyer_email_ph = /** @type {(inputs: Order_Form_Invoice_Buyer_Email_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: ketoan@congty.vn`)
};

/**

* @param {Order_Form_Invoice_Buyer_Email_PhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_email_ph = /** @type {((inputs?: Order_Form_Invoice_Buyer_Email_PhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_Email_PhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_email_ph(inputs)
});